import config from "@/config";
import { useRouter } from "@tanstack/react-router";
import { useLogout } from "@privy-io/react-auth";
import { removeCookie } from "typescript-cookie";
import { useAuth } from "@/provider/AuthProvider";

// Custom hook for navigation utilities
export function useNavigationUtils() {
  const router = useRouter();
  const { resetAuth } = useAuth();

  const { logout } = useLogout({
    onSuccess: () => {
      router.navigate({
        to: config.PATHNAME.HOME,
      });
    },
  });

  const handleLogout = () => {
    console.log("🔴 ~ handleLogout ~ logout");
    logout();
    resetAuth();
    localStorage.clear();
    sessionStorage.clear();
    removeCookie("accessToken");
    router.navigate({
      to: config.PATHNAME.HOME,
    });
  };

  const handlePath = (path: string | undefined) => {
    router.navigate({ to: path });
  };

  return {
    handleLogout,
    handlePath,
  };
}
